'use client'
import { Tabs, Tab } from "@heroui/react";
import CrouselTransforSection from "./CrouselTransforSection";
import { HomepageCategoriesTreatmeantDataEntity } from "@/types/GetHomePageCategoriesTreatmeantDetails";

interface TypeOfTransformProps {
    categoriesData: HomepageCategoriesTreatmeantDataEntity[] | null | undefined
}

const TypeOfTransform = ({ categoriesData }: TypeOfTransformProps) => {

    const tabItems = categoriesData?.map((curr) => {

        const tempCrouselData = curr?.treatments?.map((item)=>({
            url: item?.homePageFeaturedImage?.url || '',
            alt_name: item?.homePageFeaturedImage?.alt || '',
            heading:item?.title || '',
            description:item?.homePageSubheading || '',
            slug:item?.slug || ''
        })) || []
        
        return {
            key: curr?.category?._id,
            title: curr?.category?.name || 'No Tag',
            content: <CrouselTransforSection crouselData={tempCrouselData} />,
        }
    }) || [];


    return (
        <>
            <Tabs
                key="light"
                aria-label="Tabs variants"
                variant="light"
                className="hero_tabs_parent"
                classNames={{
                    tab: "hero_single_tab",
                    tabContent: "hero_tab_content",
                    cursor: "hero_tab_cursor",
                }}
                items={tabItems}
                disableAnimation={false}
                disableCursorAnimation={false}
            >
                {(item) => (
                    <Tab key={item.key} title={item.title}>
                        {item.content}
                    </Tab>
                )}
            </Tabs>

        </>
    )
}

export default TypeOfTransform